const PPR_DOCUMENT_TYPE = 'Personal_Portfolio_Report';

const parseTimestamp = (value) => {
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : null;
};

const getEffectiveTimestamp = (file) => {
  const timestampFields = [
    file.publicationDate,
    file.uploadedAt,
    file.updatedAt,
    file.createdAt,
  ];
  const timestamp = timestampFields
    .map(parseTimestamp)
    .find((parsedTimestamp) => parsedTimestamp !== null);
  return timestamp ?? Number.NEGATIVE_INFINITY;
};

export const selectLatestAvailableFile = (files, documentType, now = new Date()) => {
  if (!Array.isArray(files)) {
    throw new TypeError('Files response must be an array');
  }

  const nowTimestamp = now.getTime();
  return files
    .filter((file) => {
      const publicationTimestamp = parseTimestamp(file.publicationDate);
      return file.documentType === documentType
        && file.status === 'Available'
        && (
          publicationTimestamp === null
          || publicationTimestamp <= nowTimestamp
        );
    })
    .reduce((latestFile, file) => {
      if (!latestFile) {
        return file;
      }

      const timestampDifference = getEffectiveTimestamp(file)
        - getEffectiveTimestamp(latestFile);
      if (timestampDifference !== 0) {
        return timestampDifference > 0 ? file : latestFile;
      }

      return Number(file.id) > Number(latestFile.id) ? file : latestFile;
    }, null);
};

const selectLatestPPR = (files, now = new Date()) => (
  selectLatestAvailableFile(files, PPR_DOCUMENT_TYPE, now)
);

export default selectLatestPPR;
